import { render, staticRenderFns } from "./ThirdPartyTransactionDetail.vue?vue&type=template&id=10a0ceb4&scoped=true"
import script from "./ThirdPartyTransactionDetail.vue?vue&type=script&lang=js"
export * from "./ThirdPartyTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0ceb4",
  null
  
)

export default component.exports